<template>
    <q-page class="full-height">
        <div class="row window-height justify-center items-center">
            <div class="col-sm-9 col-xl-8">
                <q-card class="custom-shadow">
                    <card-header title="privacy_policy" />

                    <q-card-section>
                        <q-scroll-area class="scroll-size q-px-md linkfix">
                            <div v-html="privacy"></div>
                        </q-scroll-area>
                    </q-card-section>
                </q-card>
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import CardHeader from 'components/login/desktop/CardHeader'

export default {
    i18nOptions: { namespaces: ['custom', 'common'] },

    name: 'LoginPrivacyPolicy',
    data() {
        return {
            privacies: []
        }
    },
    components: {
        'card-header': CardHeader
    },
    computed: {
        ...mapGetters({
            clients: 'params/clients',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        privacy() {
            let obj = this.privacies.find((obj) => { return obj.language === this.id_user_language_selected && obj.body !== null })
            if (obj) return obj.body
            else {
                let obj = this.privacies.find((obj) => { return obj.body !== '' })
                if (obj) return obj.body
            }
            return ''
        },

    },
    created() {
        this.getPrivacies()
    },
    methods: {
        getPrivacies() {
            this.$q.loading.show()

            this.$axios.get('/etraining_login/privacy/')
                .then(response => {
                    this.privacies = response.data
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
        }
    },
}
</script>

<style lang="scss" scoped>
@media (max-width: $breakpoint-lg-max) {
    .scroll-size {
        height: calc(70vh - 40px);
    }
}

@media (min-width: $breakpoint-lg-min) {
    .scroll-size {
        height: calc(80vh - 40px);
    }
}
</style>
